goog.provide("shadow.js.shim.module$$carbon$icons_react$es$CopyFile$default");
shadow.js.shim.module$$carbon$icons_react$es$CopyFile$default = shadow.js.require(359, {}).default;
